import React from 'react';
import styles from './self-initiated-verification-bottomsheet.module.scss';
import { BottomSheet, Button, Typography } from '@/ui-kit';
import { OkHandIcon, VerificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import { useAuth } from '@/store/useAuth';
import WebApp from '@twa-dev/sdk';

interface Props {
    isVerificationModalOpen: boolean;
    setIsVerificationModalOpen: (val: boolean) => void;
    onOkClicked?: () => Promise<boolean>;
}

export const SelfInitiatedVerificationBottomsheet: React.FC<Props> = ({
    isVerificationModalOpen,
    setIsVerificationModalOpen,
    onOkClicked,
}) => {
    const userData =
        useAuth((state) => state.getUser());

    const handleBtnClick = async () => {
        if (onOkClicked) {
            const isSuccess = await onOkClicked?.()
            if (!isSuccess) return
        }
        const { id, public_name } = userData ?? {};
        const params = new URLSearchParams({
            text: `Привет! Хочу пройти верификацию. (${id}, ${public_name})`
        });

        WebApp.openTelegramLink(`https://t.me/euphora_support?${params}`);

        setIsVerificationModalOpen(false)
    }
    
    return (
        <BottomSheet
            isOpen={isVerificationModalOpen}
            isDeskorTop={false}
            onClose={() => setIsVerificationModalOpen(false)}
            className={styles.bottomsheet}
            overlayClassName={styles.bottomsheetOverlay}>
            <div className={styles.verificationModalContent}>
                <VerificationIcon className={styles.verificationModalContentIcon} />
                <div className={styles.verificationModalContentHeader}>
                    <Typography
                        className={styles.verificationModalContentHeaderTitle}
                        variant={'h5'}
                        fontWeight={'bold'}>
                        После прохождения верификации
                        <br />
                        личности в профиле появится
                        <br />
                        <span className={styles.iconWrapper}>
                            значок
                            <VerifiedAccountIcon width={20} height={20} />
                        </span>
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentHeaderDesc}>
                        Отправь видео в поддержку и скажи<br />на камеру: «Путешествия» и покажи рукой<br />так:
                    </Typography>
                    <OkHandIcon width={40} height={40} />
                </div>
                <div className={styles.verificationModalContentFootnote}>
                    <Typography
                        className={styles.verificationModalContentFootnoteTitle}>
                        Мы за честное и безопасное общение. Поэтому предлагаем участникам пройти простую верификацию.
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentFootnoteSubtitle}>
                        Видео не передается третьим лицам и автоматически удаляется после проверки
                    </Typography>
                    <div className={styles.verificationModalContentFootnoteBtns}>
                        <Button
                            typeColor="orange"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={handleBtnClick}>
                            Пройти верификацию
                        </Button>
                        <Button
                            typeColor="white"
                            textColor="black"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={() => setIsVerificationModalOpen(false)}>
                            Позже
                        </Button>
                    </div>
                </div>
            </div>
        </BottomSheet>
    );
};
